import { Outlet } from "react-router-dom"

const SensorParametersComponent = () => {
    return <Outlet />
}

export default SensorParametersComponent;